import { LmgService } from "../resource";

const BranchModule = {
  namespaced: true,
  state: {
    datas: [],
    data: {},
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.BranchCreate(payload);
    },
    updateData({ commit, state }, payload) {
      return LmgService.BranchUpdate(payload);
    },
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.BranchList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    
  }
};

export default BranchModule;
